import { ErrorMessage, Field, Form, Formik } from 'formik';
import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { BiErrorCircle } from 'react-icons/bi';
import { useDispatch } from 'react-redux';
import { Button, Modal, TextField } from 'src/components';
import LabelCustomSelect from 'src/components/LabelSelect/LabelCustomSelect';
import SlideInModal from 'src/components/slideInModal';
import useFetch from 'src/hooks/useFetch';
import { fetchLabel } from 'src/redux/action/label.action';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import * as Yup from 'yup';

interface IProps {
  handleModal: () => void;
  showModal: boolean;
  fetchData: () => void;
  setEditLabel: (val: boolean) => void;
  setEditLabelId: (val: string) => void;
  editLabel: boolean;
  editLabelId: string;
  editLabelData: any;
}

const FORM_VALIDATION = Yup.object().shape({
  name: Yup.string()
    .min(3, 'Label Name must a at least 3 character long')
    .required('Label Name is required'),
  categories: Yup.array(),
});

const AddLabel: React.FC<IProps> = ({
  showModal,
  handleModal,
  editLabel,
  editLabelId,
  setEditLabel,
  setEditLabelId,
  editLabelData,
}) => {
  const { data: categoryData } = useFetch('/categories');
  const filterCategory = categoryData?.categories
    ? categoryData?.categories?.map((item: any) => {
        return {
          name: item?.categoryInfo?.name,
          id: item?.categoryInfo?.id,
        };
      })
    : [];
  const [errorMsgPost, setErrorMsgPost] = React.useState('');
  const dispatch = useDispatch();

  const intValues = {
    name: editLabel ? editLabelData?.name : '',
    categories: editLabel
      ? editLabelData?.categories?.map((category: any) => category.id)
      : [],
  };
  const handleSubmit = async (val: any, { resetForm }: any) => {
    const payload = {
      id: editLabelId,
      name: val?.name,
      categories: val?.categories,
    };
    try {
      if (editLabel) {
        await Service.put('/labels', payload);
      } else {
        await Service.post('/labels', payload);
      }
      handleModal();
      dispatch(fetchLabel() as any);
      toastAlert(
        'success',
        `${val?.name} label is successfully ${editLabel ? 'edited' : 'added'}`
      );
      resetForm();
      setErrorMsgPost('');
    } catch (err: any) {
      setErrorMsgPost(err?.response?.data?.message);
    }
  };

  return (
    <>
      {showModal && (
        <SlideInModal
          showModal={showModal}
          title={editLabel ? 'Edit label' : ' Add Label'}
          onClick={handleModal}
          className="bg-pure-white z-[9999]"
        >
          <div className="mx-5 mt-4">
            {errorMsgPost && (
              <p className="text-warning text-center text-sm font-semibold capitalize">
                {errorMsgPost}
              </p>
            )}
            <Formik
              initialValues={intValues}
              validateOnMount
              validationSchema={FORM_VALIDATION}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting, isValid, values, setFieldValue }) => (
                <Form className="mt-5">
                  <TextField
                    label="Name"
                    name="name"
                    defaultValue={
                      editLabel && editLabelData ? editLabelData?.name : ''
                    }
                  />

                  <div>
                    {' '}
                    <Field
                      name="categories"
                      options={filterCategory}
                      className={'mt-3 mb-5'}
                      component={LabelCustomSelect}
                      isMulti={true}
                      label="Categories"
                      defaultValue={
                        editLabelData?.categories &&
                        editLabelData?.categories.map(
                          (item: any) =>
                            item.id && {
                              label: item.name,
                              value: item.id,
                            }
                        )
                      }
                    />
                  </div>

                  <div className="relative mt-10">
                    <BiErrorCircle
                      size={17}
                      color="#fff"
                      className="absolute top-2 mx-2"
                    />
                    <ErrorMessage
                      component="div"
                      name={'end_date'}
                      className="bg-warning bg-opacity-80 text-pure-white mt-1 text-xs inline-block px-7 py-1 rounded-sm"
                    />
                  </div>

                  <div className="flex items-center justify-end mt-14">
                    <Button
                      text={editLabel ? 'edit label' : ' Add Label'}
                      variant="primary"
                      isSubmitting={isSubmitting}
                      isValid={isValid}
                      type="submit"
                    />
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </SlideInModal>
      )}
    </>
  );
};

export default React.memo(AddLabel);
